/**
 * Returns an array of formNodes sharing the same crossGroupId and code as the given targetNode.
 *
 * @param {[]Object} formNodes
 * @param {Object} targetNode
 * @returns {[]Object}
 */
export const getCrossGroupTargetNodes = (formNodes, targetNode) =>
    formNodes.filter((formNode) => formNode.crossGroupId === targetNode.crossGroupId && formNode.id !== targetNode.id);
